import EventHandler, { HTML_EVENT } from "./EventHandler";
var ResizeHandler = /** @class */ (function () {
    function ResizeHandler() {
        this.canvas = document.getElementsByTagName("canvas")[0];
    }
    ResizeHandler.getInstance = function () {
        if (!this._instance) {
            this._instance = new ResizeHandler();
        }
        return this._instance;
    };
    ResizeHandler.prototype.resize = function () {
        // if (this.isPaused) return;
        var innerWidth = window.innerWidth, innerHeight = window.innerHeight;
        var ir = innerWidth / innerHeight;
        var r = this.width / this.height;
        var w;
        var h;
        if (r < ir) {
            w = innerWidth;
            h = innerWidth / r;
        }
        else {
            w = innerHeight * r;
            h = innerHeight;
        }
        this.canvas.style.width = "".concat(w, "px");
        this.canvas.style.height = "".concat(h, "px");
    };
    ResizeHandler.prototype.load = function (_a) {
        var _this = this;
        var width = _a.width, height = _a.height;
        this.width = Number(width);
        this.height = Number(height);
        this.resize();
        EventHandler.getInstance().on(HTML_EVENT.RESIZE, function () { return _this.resize(); });
        // window.addEventListener("content_pause", (e) => {
        //   console.log("CONTENT_PAUSE is triggered!");
        //   isAdPlaying = true;
        // });
        // window.addEventListener("content_resume", (e) => {
        //   console.log("CONTENT_RESUME is triggered!");
        //   isAdPlaying = false;
        // });
    };
    ResizeHandler.prototype.onResize = function (callback) {
        EventHandler.getInstance().on(HTML_EVENT.RESIZE, function () { return callback(); });
    };
    ResizeHandler.prototype.onScaleResize = function (scene, callback) {
        scene.scale.on("resize", callback);
    };
    return ResizeHandler;
}());
export default ResizeHandler;
